module.exports = __webpack_public_path__ + "img/tarj1-2.885c9ae3.svg";